/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "ScrollToPlugin|plugins" }] */
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/all';

gsap.registerPlugin(ScrollToPlugin);

const plugins = [ScrollToPlugin];

function ReturnToTop() {
  const iconLink = document.getElementById('return-to-top');
  if (!iconLink) return; // only on home page
  window.iconShow = true; // initial state flag derived from css

  const hide = () => {
    if (window.iconShow) {
      window.iconShow = false;
      gsap.to(iconLink, {
        duration: 0.2,
        opacity: 0,
        ease: 'cubic-bezier(.41,.73,.47,.96)',
      });
    }
  };

  const show = () => {
    if (!window.iconShow) {
      window.iconShow = true;
      gsap.to(iconLink, {
        duration: 0.2,
        opacity: 1,
        ease: 'cubic-bezier(.41,.73,.47,.96)',
      });
    }
  };

  const animate = (e) => {
    e.stopPropagation();
    gsap.to(window, {
      scrollTo: {
        duration: 0.5,
        y: 0,
        autoKill: false,
      },
      ease: 'cubic-bezier(.41,.73,.47,.96)',
      onComplete: () => hide,
    });
  };

  const offsetY = 100;
  const getScrollTop = () => (window.scrollTop || window.pageYOffset
      || (document.body ? document.body.scrollTop : 0));

  if (iconLink) {
    hide();
    iconLink.addEventListener('click', e => animate(e), false);
    iconLink.addEventListener('touch', e => animate(e), false);
    window.onscroll = () => {
      const scrollY = getScrollTop();
      if (scrollY > offsetY) {
        show();
      } else {
        hide();
      }
    };
  }
}

export default ReturnToTop;
